/**
 * Configuration constants for the local editor server.
 * Centralizes all magic numbers and configuration values.
 */
export const editorConfig = {
  /**
   * Server configuration
   */
  server: {
    /** Default port for the editor server */
    port: 9100,
    /** Default port for the local Zuplo gateway */
    gatewayPort: 9000,
    /** Maximum request body size (100MB) */
    bodyLimit: 100 * 1024 * 1024,
    /** Default host for the server */
    host: "localhost",
  },

  /**
   * Server-Sent Events configuration
   */
  sse: {
    /**
     * Keep-alive interval in milliseconds (30 seconds)
     * Prevents proxy/browser timeouts for long-lived connections
     */
    keepAliveInterval: 30000,
  },

  /**
   * File operation configuration
   */
  file: {
    /** Maximum file size for uploads (100MB) */
    maxFileSize: 100 * 1024 * 1024,

    /** Allowed directories for file operations */
    allowedDirs: ["config", "modules", "schemas"] as const,
  },

  /**
   * File watching configuration
   */
  watch: {
    /** Directories to watch for changes */
    watchedDirs: ["config", "modules", "schemas"] as const,
  },
} as const;
